@let user = authService.user;

@if (context()) {
  <div>
    @if (!canWrite()) {
      <div class="scopeForm">
        <h4>{{ 'igo.context.permission.readOnlyTitle' | translate }}</h4>
        <p>{{ 'igo.context.permission.readOnlyMsg' | translate }}</p>
      </div>
    } @else {
      <div class="scopeForm">
        <mat-radio-group
          [(ngModel)]="context().scope"
          (change)="onScopeChanged(context())"
        >
          <mat-radio-button value="private">
            {{ 'igo.context.permission.scope.private' | translate }}
          </mat-radio-button>
          <mat-radio-button value="protected">
            {{ 'igo.context.permission.scope.shared' | translate }}
          </mat-radio-button>
          @if (authService.isAdmin) {
            <mat-radio-button value="public">
              {{ 'igo.context.permission.scope.public' | translate }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
    }
    @if (context().scope !== 'private') {
      @if (canWrite()) {
        <form [formGroup]="form" (ngSubmit)="handleFormSubmit(form.value)">
          <mat-form-field class="full-width">
            <input
              matInput
              required
              [placeholder]="'igo.context.permission.user' | translate"
              [formControl]="formControl"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="onProfilSelected($event.option.value)"
              [displayWith]="displayFn"
            >
              @for (profil of this.profils(); track profil) {
                <mat-option [value]="profil">
                  {{ profil.title }}<br />
                  <small>{{ profil.name }}</small>
                </mat-option>
              }
            </mat-autocomplete>
            <mat-error>
              {{ 'igo.context.permission.profilRequired' | translate }}
            </mat-error>
          </mat-form-field>
          <mat-radio-group formControlName="typePermission">
            <mat-radio-button value="read">
              {{ 'igo.context.permission.read' | translate }}
            </mat-radio-button>
            <mat-radio-button value="write">
              {{ 'igo.context.permission.write' | translate }}
            </mat-radio-button>
          </mat-radio-group>
          <div class="igo-form-button-group">
            <button matButton="elevated" type="submit" [disabled]="!form.valid">
              {{ 'igo.context.permission.addBtn' | translate }}
            </button>
          </div>
        </form>
      }
      @if (permissions()) {
        <igo-list>
          @if (permissionsRead().length) {
            <igo-collapsible
              [title]="'igo.context.permission.' + 'read' | translate"
            >
              @for (permission of permissionsRead(); track permission) {
                <igo-context-permission-item
                  [permission]="permission"
                  [canWrite]="canWrite()"
                  [user]="user"
                  (delete)="onRemovePermission($event)"
                />
              }
            </igo-collapsible>
          }
          @if (permissionsWrite().length) {
            <igo-collapsible
              [title]="'igo.context.permission.' + 'write' | translate"
            >
              @for (permission of permissionsWrite(); track permission) {
                <igo-context-permission-item
                  [permission]="permission"
                  [canWrite]="canWrite()"
                  [user]="user"
                  (delete)="onRemovePermission($event)"
                />
              }
            </igo-collapsible>
          }
        </igo-list>
      }
    }
  </div>
}
